import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';

export const getSectionWidths = (state: State) => state.ui.SectionWidths;

export const getScopeWidth = createSelector(
	[getSectionWidths],
	(sectionWidths) => sectionWidths.scope,
);

export const getFieldsWidth = createSelector(
	[getSectionWidths],
	(sectionWidths) => sectionWidths.fields,
);

export const getTimelineWidth = createSelector(
	[getSectionWidths],
	(sectionWidths) => sectionWidths.timeline,
);

export const getTimelineExportWidth = createSelector(
	[getSectionWidths],
	(sectionWidths) => sectionWidths.timelineExport,
);
